import { checkDescrepencyExistsInArrays } from '../utils/dataModificaionUtil';

const updateDiscrepancyReportUtil = ({
    storedItemTableData,
    bundleHeadersArr,
    usageDetails,
    myCaseRefId,
    dispatch,
    putDisparencyData,
}) => {
    // For comparing UsageDetailsProducts(constant) and StoredItemDataProducts(varies)
    const nonAdditionalCartEntryItem = storedItemTableData?.filter(
        (x) => !x?.isAdditionalCartEntry
    );

    const nonAdditionalCartEntryBundle = nonAdditionalCartEntryItem.filter(
        (x) => x.isBundleItem && x.children && x.children.length > 0
    );

    const bundleChildItems =
        nonAdditionalCartEntryBundle &&
        nonAdditionalCartEntryBundle.reduce(
            (previousValue, currentValue) => {
                const childItems = currentValue.children
                    .filter(
                        (child) =>
                            !bundleHeadersArr?.includes(
                                (child.cfn || child.productCFN).toUpperCase()
                            )
                    )
                    .map((child) => ({
                        ...child,
                        parentCFN: currentValue.cfn || currentValue.productCFN,
                        accountOwned:
                            child.isAccountOwned || currentValue.accountOwned,
                    }));
                return previousValue.concat(childItems);
            },
            []
        );

    const usageProducts = checkDescrepencyExistsInArrays(
        usageDetails?.products?.filter((x) => !x?.isAdditionalCartEntry),
        usageDetails?.discrepancyExists
    );

    const prodObj = storedItemTableData
        .concat(bundleChildItems)
        ?.filter((x) => !x?.isAdditionalCartEntry)
        .map((item, index) => {
            const otherQty = item.lotSerial
                ?.map((e) => (e.other ? e.other : 0))
                ?.reduce((a, b) => Number(a) + Number(b), 0);
            const usedQty = item.lotSerial
                ?.map((e) => (e.used ? e.used : 0))
                ?.reduce((a, b) => Number(a) + Number(b), 0);
            const lotSerialNumber = item.lotSerial
                ?.map((e) => e.Serial)
                ?.join(',');
            return {
                counter: index,
                discription: item.description,
                entryNum: index,
                isAccountOwned: item.accountOwned,
                itemNumber: index,
                lotSerialNumber: lotSerialNumber,
                modifiedByRep: false,
                otherQuantity: otherQty,
                productCFN: item.cfn,
                salesOrg: item.salesOrg,
                uom: item.uom,
                useMadeAccountOwned:
                    item?.userMadeAccountOwned === item?.accountOwned
                        ? false
                        : true,
                usedQuantity: usedQty,
                ...(item?.parentCFN ? { parentCFN: item.parentCFN } : {}),
            };
        });

    const storedProducts = checkDescrepencyExistsInArrays(
        prodObj,
        usageDetails?.discrepancyExists
    );

    let isProductdetailsSame = true;
    for (const x of usageProducts) {
        const prodChangedItem = storedProducts?.filter(
            (y) => y?.cfn === x?.cfn
        );
        isProductdetailsSame =
            prodChangedItem &&
            Object.keys(prodChangedItem)?.length > 0 &&
            prodChangedItem[0].usedQty === x?.usedQty &&
            prodChangedItem[0].otherQty === x?.otherQty &&
            prodChangedItem[0].accountOwned === x?.accountOwned;
        if (!isProductdetailsSame) {
            break;
        }
    }

    const result =
        usageProducts?.length === storedProducts?.length && isProductdetailsSame
            ? true
            : false;

    const productsObj = {
        products: prodObj,
        sstref: myCaseRefId,
        discrepancyChanged: usageDetails?.discrepancyExists ? !result : false,
    };
    dispatch(putDisparencyData(productsObj));
};

export default updateDiscrepancyReportUtil;